import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "../demo/rest.resolver";

const l0_counts = [0, 16, 19, 16, 3, 12, 15, 10];

// @ts-ignore
export const mass_download: Record<Partial<RestCallsKey>, MockRestCall> = {
  "mass-download.counters-summary": {
    delay: 1000,
    payload: async (ids: string[]) => {
      const { SharedState } = await import("@/common/state");
      return ids.map((id, index) => {
        const { code } = SharedState.allInfoTypes.value[id];
        return [id, l0_counts[code]];
      });
    },
  },
  "mass-download.for-l0": {
    delay: 1000,
    payload: async (p: { l0_id: string }) => {
      const { SharedState } = await import("@/common/state");
      const { code } = SharedState.allInfoTypes.value[p.l0_id];
      return {
        cursor: "",
        objects: Object.entries(SharedState.employees_full_objects.value)
          .slice(0, l0_counts[code])
          .map(([id, { dep_name, email, name }]) => {
            return {
              id: id,
              name,
              email,
              download_count: Math.floor(Math.random() * 80),
              department: dep_name,
            };
          })
          .sort((a, b) => b.download_count - a.download_count),
      };
    },
  },
};
